import React from 'react';
import componentProps from '../../../../helpers/componentProps';
import { applyComponentTheme } from '../../../../theme';
import { SubPanelButtonProps } from '../../types';
import { DesktopLabelWrapper, DesktopPanelButtonStyle } from './styles';

const DesktopPanelButton: React.FC<SubPanelButtonProps> = ({
  index,
  isSelected,
  label,
  setCurrentTabIndex,
  onClick,
  ...props
}) => {
  return (
    <DesktopPanelButtonStyle
      disabled={isSelected}
      isSelected={isSelected}
      key={index}
      onClick={(e) => {
        setCurrentTabIndex(index);
        if (onClick) {
          onClick(e);
        }
      }}
      data-testid={`Desktop-panel-button-${index}`}
      {...componentProps(props)}>
      <DesktopLabelWrapper>{label}</DesktopLabelWrapper>
    </DesktopPanelButtonStyle>
  );
};

export default applyComponentTheme(DesktopPanelButton, 'DesktopPanelButton');
